import { Controller } from "stimulus";
import {EventCurrencyChanged, EventShowFDV} from "../../events";
import {getActiveCurrency} from "../../util/currency";

export default class extends Controller {
  static targets = ["showMore", "contentBox"];

  connect() {
    this.currentPage = 1;
    this.totalMetricCurrentsCount = this.showMoreTarget.dataset.count;
    this._hideShowMoreButtonIfAllMetricCurrentsLoaded();
  }

  async showMore() {
    this.showMoreTarget.disabled = true;
    let page = this.currentPage + 1;
    let response = await fetch(`${this.showMoreTarget.dataset.url}?page=${page}`, { credentials: "same-origin" });

    if (response.status === 200) {
      let content = await response.text()
      this.contentBoxTarget.insertAdjacentHTML("beforeend", content);
      this.showMoreTarget.disabled = false;
      this._hideShowMoreButtonIfAllMetricCurrentsLoaded();
      window.dispatchEvent(new CustomEvent(EventShowFDV));
      window.dispatchEvent(new CustomEvent(EventCurrencyChanged));
    }

    this.currentPage++;
  }

  _hasLoadedAll() {
    let loadedMetricCurrentsCount = this.contentBoxTarget.getElementsByTagName("tr").length;
    return loadedMetricCurrentsCount >= this.totalMetricCurrentsCount;
  }

  _hideShowMoreButtonIfAllMetricCurrentsLoaded() {
    if (this._hasLoadedAll()) {
      this.showMoreTarget.style.display = "none";
    }
  }
}